var map = {
	"./en": "./src/web/kingdee/hr/kddate2tab/utils/moment/locale/en.js",
	"./en.js": "./src/web/kingdee/hr/kddate2tab/utils/moment/locale/en.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/web/kingdee/hr/kddate2tab/utils/moment/locale sync recursive ^\\.\\/.*$";